export enum IntegrationProviderEnum {
  META = 'meta',
  UTMIFY = 'utmify',
  TWITTER = 'twitter',
  TIKTOK = 'tiktok',
  KWAI = 'kwai'
}